/**
 * @learnzapp/core/metering — content-agnostic metered-unlock primitives
 * (period keys, derived meter state, grow-only unlock reducer, period copy).
 * Consumed by /articles today; future metered content types (questions,
 * flashcards) reuse these with their own per-type unlock maps and flags.
 */
export * from './unlockMeter';
